export default "__VITE_ASSET__Cz8yAcsH__"